export default __webpack_public_path__ + "static/media/NumpadIcon.7d73b12b.svg";